import React from 'react'
import { Button, Col, Grid, Icon, Row, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import styles from 'components/FileUploader/file-uploader.module.scss'
import StatusIcon from 'components/FileUploader/subcomponents/StatusIcon'
import clsx from 'clsx'
import format from 'utils/dateFns/format'
import { parse } from 'date-fns'

const AttachmentRow = ({ name, url, created_at, className }) => {
  return (
    <Row
      className={clsx(styles['row'], className)}
      key={'file-row-' + name}
      flexWrap={'nowrap'}
    >
      <Grid
        gap={16}
        wrap={false}
      >
        <Col className={styles['col']}>
          <StatusIcon status={'loaded'} />
        </Col>

        <Col className={clsx(styles['col'], styles['col-2'])}>
          <Grid
            direction={'column'}
            gap={4}
          >
            <Typography
              variant={'Body-15'}
              noMargin
              className={styles['row__file-name']}
            >
              {name}
            </Typography>
            <Typography
              variant={'Body-10'}
              color={'Label-Secondary'}
              noMargin
            >
              {created_at &&
                format(parse(created_at, "yyyy-MM-dd'T'HH:mm:ssXXX", new Date()), 'd MM yyyy')}
            </Typography>
          </Grid>
        </Col>
        <Col className={clsx(styles['col'], styles['col-3'])}>
          <Button
            color={'Interface-Eight'}
            component={'a'}
            target={'_blank'}
            href={url}
            variant={'link'}
            ghost
            rel="noreferrer"
            noLabel
            startIcon={<Icon name={'download'} />}
            size={'s'}
          />
        </Col>
      </Grid>
    </Row>
  )
}

AttachmentRow.propTypes = {
  url: PropTypes.string,
  created_at: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  total: PropTypes.number,
  remove: PropTypes.func,
}

export default AttachmentRow
